import { updateConsumerAdsExperimentMode } from '../services/updateConsumerAdsExperimentMode';
import consumerAdsExperimentModeSetValue from '../utils/consumerAdsExperimentModeSetValue';
import isNewUser from '../utils/isNewUser';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default async function updateAdExp2UserOption() {
    // Kill switch to stop stamping more properties for the users. This does mean the users which are already stamped have stop the experiments
    if (isFeatureEnabled('fwk-ads-exp2-StopStampUserOption')) {
        return;
    }

    let userConsumerAdsExpMode = getUserConfiguration().UserOptions.ConsumerAdsExperimentMode;

    // We do not stamp the users who already got 'NoExpreiment' which mean they are already in the experiment
    if (userConsumerAdsExpMode != null && userConsumerAdsExpMode != 'NoExperiment') {
        return;
    }

    // For the non-users, we do not stamp the properties
    if (!isNewUser()) {
        return;
    }

    let consumerAdsExperimentModeNumber: number;
    if (isFeatureEnabled('fwk-ads-exp2-DisplayOffNativeOff')) {
        consumerAdsExperimentModeNumber = consumerAdsExperimentModeSetValue('DisplayOffNativeOff');
    }
    if (isFeatureEnabled('fwk-ads-exp2-DisplayOffNativeOther')) {
        consumerAdsExperimentModeNumber = consumerAdsExperimentModeSetValue(
            'DisplayOffNativeOther'
        );
    }

    if (isFeatureEnabled('fwk-ads-exp2-DisplayOffNativeInbox')) {
        consumerAdsExperimentModeNumber = consumerAdsExperimentModeSetValue(
            'DisplayOffNativeInbox'
        );
    }

    if (isFeatureEnabled('fwk-ads-exp2-DisplayOnNativeOff')) {
        consumerAdsExperimentModeNumber = consumerAdsExperimentModeSetValue('DisplayOnNativeOff');
    }

    if (isFeatureEnabled('fwk-ads-exp2-DisplayOnNativeOther')) {
        consumerAdsExperimentModeNumber = consumerAdsExperimentModeSetValue('DisplayOnNativeOther');
    }

    if (isFeatureEnabled('fwk-ads-exp2-DisplayOnNativeInbox')) {
        consumerAdsExperimentModeNumber = consumerAdsExperimentModeSetValue('DisplayOnNativeInbox');
    }

    logUsage(
        'UpdateAdExp2UserOption',
        { expMode: consumerAdsExperimentModeNumber },
        {
            isCore: true,
        }
    );

    updateConsumerAdsExperimentMode(consumerAdsExperimentModeNumber);
}
